import { useState } from 'react';

export type AlertMessage = {
  type: 'success' | 'error' | 'info';
  message: string;
};

export function useAlertMessage() {
  const [alertMessage, setAlertMessage] = useState<AlertMessage | undefined>(
    undefined,
  );

  const resetAlertMessage = () => {
    setAlertMessage(undefined);
  };

  const setSuccessMessage = (message: string) => {
    setAlertMessage({ type: 'success', message });
  };

  const setErrorMessage = (message: string) => {
    setAlertMessage({ type: 'error', message });
  };

  const setInfoMessage = (message: string) => {
    setAlertMessage({ type: 'info', message });
  };

  return {
    alertMessage,
    resetAlertMessage,
    setSuccessMessage,
    setErrorMessage,
    setInfoMessage,
  };
}
